import React, { useEffect } from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { useLocation, Link } from 'react-router-dom';
export const PublicCoursesPage = () => {
  const location = useLocation();
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
    // Reset any scroll position caching
    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    }
  }, [location]);
  return <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-5782">
      <Navbar data-id="element-5783" />
      <main className="pt-20 pb-16" data-id="element-5784">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5785">
          {/* Header */}
          <div className="py-8 mb-12" data-id="element-5786">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-5787">
              Courses — Coming Soon
            </h1>
            <p className="text-lg text-gray-300" data-id="element-5788">
              Maestro Connect is preparing a dedicated courses section focused
              on high-quality music education.
            </p>
            <p className="text-lg text-gray-300 mt-2" data-id="element-5789">
              This area will feature structured courses created by experienced
              musicians and educators, covering a wide range of topics across
              instruments, theory, and the music industry.
            </p>
          </div>

          {/* What This Section Will Offer */}
          <section className="bg-white/5 rounded-xl p-8 border border-white/10 mb-8" data-id="element-5790">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-5791">
              What This Section Will Offer
            </h2>
            <ul className="space-y-3 text-gray-300" data-id="element-5792">
              <li className="flex items-start" data-id="element-5793">
                <span className="mr-3" data-id="element-5794">•</span>
                <span data-id="element-5795">
                  Instrument-focused courses (piano, guitar, violin, drums, and
                  more)
                </span>
              </li>
              <li className="flex items-start" data-id="element-5796">
                <span className="mr-3" data-id="element-5797">•</span>
                <span data-id="element-5798">Music theory, harmony, and composition</span>
              </li>
              <li className="flex items-start" data-id="element-5799">
                <span className="mr-3" data-id="element-5800">•</span>
                <span data-id="element-5801">Music business, publishing, and career education</span>
              </li>
              <li className="flex items-start" data-id="element-5802">
                <span className="mr-3" data-id="element-5803">•</span>
                <span data-id="element-5804">
                  Courses created by professional educators and working
                  musicians
                </span>
              </li>
            </ul>
          </section>

          {/* How Courses Will Be Selected */}
          <section className="bg-white/5 rounded-xl p-8 border border-white/10 mb-8" data-id="element-5805">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-5806">
              How Courses Will Be Selected
            </h2>
            <p className="text-gray-300 mb-4" data-id="element-5807">
              Our goal is quality and credibility.
            </p>
            <p className="text-gray-300 mb-3" data-id="element-5808">Courses may include:</p>
            <ul className="space-y-3 text-gray-300 mb-4" data-id="element-5809">
              <li className="flex items-start" data-id="element-5810">
                <span className="mr-3" data-id="element-5811">•</span>
                <span data-id="element-5812">
                  Original courses created specifically for Maestro Connect
                </span>
              </li>
              <li className="flex items-start" data-id="element-5813">
                <span className="mr-3" data-id="element-5814">•</span>
                <span data-id="element-5815">
                  Collaborations with established educators and creators
                </span>
              </li>
              <li className="flex items-start" data-id="element-5816">
                <span className="mr-3" data-id="element-5817">•</span>
                <span data-id="element-5818">
                  Carefully selected third-party educational content where
                  appropriate
                </span>
              </li>
            </ul>
            <p className="text-gray-300" data-id="element-5819">
              Each course will be reviewed to ensure it provides clear
              educational value and practical learning outcomes.
            </p>
          </section>

          {/* Status */}
          <section className="bg-white/5 rounded-xl p-8 border border-white/10 mb-8" data-id="element-5820">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-5821">Status</h2>
            <p className="text-gray-300" data-id="element-5822">
              This section is currently under development and will launch after
              the core platform release. Courses will be added gradually.
            </p>
          </section>

          {/* Get Notified */}
          <section className="bg-white/5 rounded-xl p-8 border border-white/10 text-center" data-id="element-5823">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-5824">Get Notified</h2>
            <p className="text-gray-300 mb-6" data-id="element-5825">
              Join the waitlist to be notified when courses become available.
            </p>
            <Link to="/" className="inline-block bg-deep-pink hover:bg-burgundy text-white font-medium py-3 px-8 rounded-lg transition-colors" data-id="element-5826">
              Join the Waitlist
            </Link>
          </section>
        </div>
      </main>
      <Footer data-id="element-5827" />
    </div>;
};